<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div class="min-h-full">

    <header class="bg-white shadow">
      <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <h1 class="text-3xl font-bold text-gray-900">Dashboard</h1>
      </div>
    </header>
    <main>
      <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <!-- Replace with your content -->
        <div class="px-4 py-6 sm:px-0">
          <div class="border-4 border-dashed border-gray-200 rounded-lg h-96" />
          <p>Count is {{mainStore.count}}, double is {{mainStore.double}}</p>
        </div>
        <!-- /End replace -->
      </div>
    </main>
  </div>
</template>

